'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxGridpanel } from './Gridpanel'
import { GridpanelProps } from './Gridpanel'
import styles from './Gridpanel.module.css'

interface GridpanelBlokProps {
  blok: {
    preTitle: GridpanelProps['preTitle']
    title: GridpanelProps['title']
    uppercaseTitle: GridpanelProps['titleUpperCase']
    addBoldTitle: GridpanelProps['titleBold']
    postTitle: SbBlokData[]
    items: SbBlokData[]
    button: SbBlokData[]
    itemsPerRow: GridpanelProps['itemsPerRow']
    force2col?: GridpanelProps['force2col']
    padding?: SbBlokData[]
    background?: SbBlokData[]
    colour?: SbBlokData[]
    alignment?: SbBlokData[]
    feature?: boolean
    flexFull?: boolean
    compact?: boolean
    borderStyle?: GridpanelProps['borderStyle']
    featureVariant?: GridpanelProps['featureVariant']
    sliderOnMobile?: boolean
    darkPagination?: boolean
    fullWidth?: boolean
  } & SbBlokData
}

const Gridpanel: FC<GridpanelBlokProps> = ({ blok }) => {
  let stylePanel = stylePanelSBData(blok.colour, blok.background, blok.alignment, blok.padding)

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxGridpanel
        preTitle={blok.preTitle}
        postTitle={
          blok.postTitle && blok.postTitle[0]
            ? blok.postTitle.map((nestedBlok: SbBlokData) => (
                <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
              ))
            : null
        }
        titleBold={blok.addBoldTitle}
        itemsPerRow={blok.itemsPerRow}
        force2col={blok.force2col ?? false}
        title={blok.title}
        titleUpperCase={blok.uppercaseTitle}
        items={
          blok.items &&
          blok.items.map((nestedBlok: SbBlokData) => (
            <div className={styles['gridItem']} key={nestedBlok._uid}>
              <StoryblokServerComponent blok={nestedBlok} />
            </div>
          ))
        }
        button={
          blok.button &&
          blok.button.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        textColor={stylePanel.textColor}
        backgroundColor={stylePanel.backgroundColor}
        padding={stylePanel.padding}
        alignment={stylePanel.alignment as 'left' | 'center' | 'right'}
        feature={blok.feature ? blok.feature : false}
        flexFull={blok.flexFull ? blok.flexFull : false}
        compact={blok.compact ? blok.compact : false}
        borderStyle={blok.borderStyle ? blok.borderStyle : 'primary'}
        featureVariant={blok.featureVariant ? blok.featureVariant : 'primary'}
        sliderOnMobile={blok.sliderOnMobile ? blok.sliderOnMobile : false}
        darkPagination={blok.darkPagination ? blok.darkPagination : false}
        fullWidth={blok.fullWidth ? blok.fullWidth : false}
      />
    </div>
  )
}

export default Gridpanel
